import styled from 'styled-components';
import theme from '../utils/theme';

const Portafolio = styled.div`
    width: 100%;
    height: auto;
    background: ${theme.fondo};
    padding-bottom: 80px !important;
    padding-top: 80px !important;
`;

const Title = styled.h1`
    padding-top: 20px !important;
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    font-family: 'Raleway', sans-serif;
    color: ${theme.letra} !important;

    @media screen and (max-width: 1024px) {
        font-size: 28px;
    }
`;

const Description = styled.p`
    font-weight: 400;
    font-family: 'Raleway', sans-serif;
    font-size: 18px;
    line-height: 1.6;
    width: 55vw;
    margin: 0 auto !important;
    text-align: center;
    margin-top: 16px !important;
    color: ${theme.letraClara};

    @media screen and (max-width: 1024px) {
        width: 90%;
        font-size: 16px;
    }
`;

const MoonTripContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    background: ${theme.fondoOscuro};
    margin-top: 60px !important;
    padding: 60px 8% !important;
    border-radius: 20px;
    
    /* Previene el desbordamiento X respetando la barra lateral */
    width: auto;
    max-width: 1200px;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box;
    box-shadow: 0 20px 25px -5px rgba(15, 23, 42, 0.15);

    @media screen and (max-width: 1024px) {
        flex-direction: column;
        padding: 40px 20px !important;
        width: 100%;
        border-radius: 0;
    }
`;

const MoontripImgBox = styled.div`
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;

    .moontrip-mockup {
        width: 100%;
        max-width: 280px;
        height: auto;
        filter: drop-shadow(0 20px 13px rgba(0, 0, 0, 0.3));
    }

    @media screen and (max-width: 1024px) {
        width: 100%;
    }
`;

const MoonTripContentBox = styled.div`
    width: 60%;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1024px) {
        width: 100%;
    }
`;

const TitleMoonTrip = styled.h3`
    text-align: left;
    color: ${theme.letraBlanca};
    font-family: "Funnel Sans", sans-serif;
    font-size: 32px;
    font-weight: 700;

    @media screen and (max-width: 1024px) {
        text-align: center;
        font-size: 26px;
    }
`;

const DescriptionMoonTrip = styled.p`
    font-weight: 400;
    font-family: 'Raleway', sans-serif;
    font-size: 16px;
    line-height: 1.6;
    margin-top: 16px !important;
    color: ${theme.letraMutedOscura};
    text-align: left;

    @media screen and (max-width: 1024px) {
        text-align: center;
    }
`;

const ButtonBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-top: 28px !important;

    @media screen and (max-width: 1024px) {
        justify-content: center;
    }
`;

const MoontripLink = styled.a`
    background-color: ${theme.azulFuerte};
    border-radius: 8px;
    color: ${theme.letraBlanca};
    padding: 12px 24px !important;
    border: none;
    text-decoration: none;
    font-weight: 600;
    font-size: 15px;
    font-family: 'Raleway', sans-serif;
    transition: background-color 200ms ease-in-out, transform 200ms ease-in-out;

    &:hover {
        background-color: ${theme.azulHover};
        transform: translateY(-2px);
    }
`;

const Proyectos = styled.div`
    width: 90%;
    margin: 0 auto !important;
    height: auto;
    margin-top: 60px !important;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;

    @media screen and (max-width: 1024px) {
        width: 100%;
    }
`;

const Proyecto = styled.div`
    width: 45%;
    height: 280px !important;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 10px 15px -3px rgba(15, 23, 42, 0.08);

    @media screen and (max-width: 800px) {
        width: 90%;
    }
`;

const Figura = styled.figure`
    width: 100%;
    height: 100%;
    margin: 0 !important;
    position: relative !important;
    overflow: hidden;
`;

const Imagen = styled.img`
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 500ms ease-in-out;

    ${Proyecto}:hover & {
        transform: scale(1.05);
    }
`;

const FigCaption = styled.figcaption`
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
    background: rgba(15, 23, 42, 0.88);
    backdrop-filter: blur(4px);
    box-sizing: border-box;

    ${Proyecto}:hover & {
        opacity: 1;
    }
`;

const H2 = styled.h2`
    text-align: center;
    margin-bottom: 20px !important;
    font-family: "Raleway", sans-serif;
    color: ${theme.letraBlanca};
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
`;

const DivCentrar = styled.div`
    display: flex;
    justify-content: center;
`;

const Boton = styled.a`
    font-size: 15px;
    padding: 10px 20px !important;
    font-weight: 600;
    font-family: "Raleway", sans-serif;
    color: ${theme.letraBlanca};
    background-color: ${theme.azulFuerte};
    border: 1px solid ${theme.azulFuerte} !important;
    border-radius: 8px !important;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out;
    text-decoration: none;

    &:hover {
        background-color: ${theme.azulHover};
        border-color: ${theme.azulHover} !important;
    }
`;

const SpanIcono = styled.span`
    height: 16px;
    width: 16px;
    color: ${theme.letraBlanca};
    margin-left: 8px !important;
    display: flex;
    align-items: center;

    svg {
        fill: ${theme.letraBlanca};
        width: 100%;
        height: 100%;
    }
`;

export {
  Portafolio,
  Title,
  Description,
  MoonTripContainer,
  MoontripImgBox,
  MoonTripContentBox,
  TitleMoonTrip,
  DescriptionMoonTrip,
  ButtonBox,
  MoontripLink,
  Proyectos,
  Proyecto,
  Figura,
  Imagen,
  FigCaption,
  H2,
  DivCentrar,
  Boton,
  SpanIcono
};